import React, { createContext, useState } from 'react';

import SwimAThonResultData from './SwimAThonResultData';

export const SwimAThonResultStateContext = createContext();

const SwimAThonResultContextProvider = ({ children }) => {
  const stateHook = useState(SwimAThonResultData.INITIAL_STATE);

  return (
    <SwimAThonResultStateContext.Provider value={stateHook}>
      {children}
    </SwimAThonResultStateContext.Provider>
  );
};

export default SwimAThonResultContextProvider;